module.exports = __webpack_public_path__ + "img/analysis-estimate-profit.fe18748b.svg";